import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarLineWeight2PxIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-line-weight-2-px"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path stroke="#48505E" strokeLinecap="round" strokeWidth={2} d="m7.5 24.5 17-17" />
        </g>
    </svg>
);
const Memo = memo(ToolbarLineWeight2PxIcon);
export default Memo;
